import React from "react";
import { Container } from "reactstrap";
import { useSelector } from "react-redux";
import { DF_LO0024Context } from "./context";
import GridHeader from "./Grid/GridHeader";
import GridBody from "./Grid/GridBody";
import withRouter from "../../../components/Common/withRouter";

const DF_LO0024 = (props) => {
  console.log("🤖 %cTransação [DF_LO0024 - Ativar/Desativar Rota]", "color:green");

  const { userProfile, isModalPage } = useSelector((state) => ({
    userProfile: state.login.profile,
    isModalPage: state.Layout.isModalPage,
  }));

  const { navigate, location, params } = props.router;

  const queryParams = new URLSearchParams(location?.search || "");
  const ID_Tabela_Frete = queryParams.get("ID_Tabela_Frete");
  const StatusAtual = queryParams.get("Ativo"); // 'S' (ativo) ou 'N' (inativo)

  return (
    <React.Fragment>
      <DF_LO0024Context.Provider
        value={{
          userProfile,
          navigate,
          location,
          params,
          ID_Tabela_Frete,
          StatusAtual,
        }}
      >
        <div
          style={{
            padding: isModalPage && "0px",
            overflow: isModalPage && "hidden",
          }}
          className="page-content"
        >
          <Container fluid={true} className="dataTable-custom-primary">
            <GridHeader />
            <GridBody />
          </Container>
        </div>
      </DF_LO0024Context.Provider>
    </React.Fragment>
  );
};

export default withRouter(DF_LO0024);